import CommonModal from "../../../UserScreen/InventoryPage/InventorySettings/components/Modals/CommonModal";
import alert_icon from "../../../asset/image/alert_icon.svg";

interface ReplaceConfigDialogProps {
    assignConfigOpen: boolean;
    assignedConfig: any;
    handleAssignConfigClose: () => void;
    handleAssignConfigConfirm: () => void;
    selectedConfig: any;
}

const ReplaceConfigDialog = (props: ReplaceConfigDialogProps) => {
    const {assignConfigOpen, assignedConfig, handleAssignConfigClose, handleAssignConfigConfirm, selectedConfig} = props;

    const element = (
        <div className="routerConfigDialogsContent">
            <div className="assignConfigBox">
                <span className="routerConfigDialogTextLaligned">Current Configuration</span>
                <div style={{padding: "0px 12px"}}>
                    <div>
                        <span className="routerConfigDialogTextLaligned">Config Name</span>
                        <span className="marginLeft8">{assignedConfig?.nickname?? "--"}</span>
                    </div>
                    <div>
                        <span className="routerConfigDialogTextLaligned">Config ID</span>
                        <span className="marginLeft8">{assignedConfig?.configId}</span>
                    </div>
                </div>
            </div>
            <div className="selectConfigBox">
                <span className="routerConfigDialogTextLaligned">New Configuration</span>
                <div style={{padding: "0px 12px"}}>
                    <div>
                        <span className="routerConfigDialogTextLaligned">Config Name</span>
                        <span className="marginLeft8">{selectedConfig?.nickname ?? "--"}</span>
                    </div>
                    <div>
                        <span className="routerConfigDialogTextLaligned">Config ID</span>
                        <span className="marginLeft8">{selectedConfig?.configId}</span>
                    </div>
                </div>
            </div>
            <div className="routerConfigDialogTextLaligned">This action will remove the current configuration from the router and apply the new one.</div>
        </div>
    )
    return(
        <CommonModal
            open={assignConfigOpen && assignedConfig}
            onClose={handleAssignConfigClose}
            onSave={handleAssignConfigConfirm}
            title={"Assign Config"}
            saveText={"Replace & Assign"}
            showOnlineOffline={false}
            showSyncStatus={false}
            children={element}
            width={"458px"}
            height={"370px"}
            titleWithCustomIcon={true}
            customIcon={alert_icon}
        />
    )
}
export default ReplaceConfigDialog